import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { IconButton, Stack, Button, Divider, Typography } from '@mui/material';
import Iconify from '../iconify.component';
import Scrollbar from '../scrollbar.component';
import Datepicker from '../../form-elements/datepicker.component';
import Channels from '../../form-elements/channels.component';

const FilterChannels = ({ values, onCancel, onSuccess, onClear }) => {
  const [filters, setFilters] = useState(values);

  const handleApplyFilters = () => {
    setTimeout(() => {
      onSuccess(filters);
    }, 250);
  };

  return (
    <>
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        sx={{ px: 1, py: 2 }}
      >
        <Typography variant="subtitle1" sx={{ ml: 1 }}>
          Filters
        </Typography>
        <IconButton onClick={onCancel}>
          <Iconify icon="eva:close-fill" />
        </IconButton>
      </Stack>

      <Divider />

      <Scrollbar
        sx={{
          height: 1,
          '& .simplebar-content': {
            height: 1,
            display: 'flex',
            flexDirection: 'column',
          },
        }}
      >
        <form id="list-data-filters" onSubmit={(e) => e.preventDefault()}>
          <Stack sx={{ p: 2 }}>
            <Channels
              appId="filterApps"
              appName="filterApps"
              label="Select App"
              sx={{ width: '100%' }}
              defaultValue={filters.filterApp || null}
              onChange={(v) => {
                setFilters({
                  ...filters,
                  filterApp: v,
                });
              }}
            />
            <Datepicker
              id="fl_start_date"
              name="fl_start_date"
              label="From Date"
              defaultValue={filters.startDate}
              clearable
              onChange={(v) => {
                setFilters({
                  ...filters,
                  startDate: v,
                });
              }}
              sx={{ width: '100%' }}
            />
            <Datepicker
              id="fl_end_date"
              name="fl_end_date"
              label="To Date"
              defaultValue={filters.endDate}
              clearable
              onChange={(v) => {
                setFilters({
                  ...filters,
                  endDate: v,
                });
              }}
              sx={{ width: '100%' }}
            />
          </Stack>
        </form>
      </Scrollbar>

      <Divider />

      <Stack spacing={1} sx={{ p: 2 }}>
        <Button
          fullWidth
          form="list-data-filters"
          type="submit"
          color="primary"
          variant="contained"
          onClick={handleApplyFilters}
        >
          Apply Filters
        </Button>
        <Button
          fullWidth
          type="button"
          color="secondary"
          variant="contained"
          startIcon={<Iconify icon="ic:round-clear-all" />}
          onClick={onClear}
        >
          Clear All
        </Button>
      </Stack>
    </>
  );
};

FilterChannels.propTypes = {
  values: PropTypes.shape().isRequired,
  onCancel: PropTypes.func.isRequired,
  onSuccess: PropTypes.func.isRequired,
  onClear: PropTypes.func.isRequired,
};

export default FilterChannels;
